module.exports = __webpack_public_path__ + "img/vertical_6_3_3.82df45cf.png";